
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IDocument, IInfoCardActionSearchCriteria, IInfoTableSearchCriteria, InfoCardExport, ISearchCriteria } from "@tylertech/tyler-api-types";

/**
 * DataSearchService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class DataSearchService<TEntity = unknown> {
    private readonly $apiService = inject(ApiService);
    
    ExportFile(document: InfoCardExport): Promise<IDocument> {
        return this.$apiService.sendAuth("IDataSearchService/ExportFile", document);
    }
    FetchCardActions(pCriteria: IInfoCardActionSearchCriteria): Promise<IInfoCardActionSearchCriteria> {
        return this.$apiService.sendAuth("IDataSearchService/FetchCardActions", pCriteria);
    }
    GetCriteria(pSearchProviderId: string): Promise<ISearchCriteria<TEntity>> {
        return this.$apiService.sendAuth("IDataSearchService/GetCriteria", pSearchProviderId);
    }
    GetFacetTotals(pCriteria: ISearchCriteria<TEntity>): Promise<ISearchCriteria<TEntity>> {
        return this.$apiService.sendAuth("IDataSearchService/GetFacetTotals", pCriteria);
    }
    Search(pCriteria: ISearchCriteria<TEntity>): Promise<ISearchCriteria<TEntity>> {
        return this.$apiService.sendAuth("IDataSearchService/Search", pCriteria);
    }
    TableViewData(pCriteria: ISearchCriteria<TEntity>): Promise<IInfoTableSearchCriteria> {
        return this.$apiService.sendAuth("IDataSearchService/TableViewData", pCriteria);
    }
}
